import React from 'react';
import { useTranslation } from 'react-i18next';
import './Marquee.css';

/**
 * props.items: array of { type: 'text'|'image'|'custom',
 *                     textKey?, defaultText?, src?, component? }
 * component is rendered directly for "custom" entries (e.g. react node)
 */
const Marquee = ({ items = [] }) => {
    const { t } = useTranslation();
    const renderNodes = (suffix) => items.map((it, idx) => {
        if (it.type === 'image') {
            return <img key={`img-${idx}-${suffix}`} className="marquee-item ad-image" src={it.src} alt="ad" />;
        } else if (it.type === 'custom') {
            return <span key={`custom-${idx}-${suffix}`} className="marquee-item">{it.component}</span>;
        } else {
            const key = it.textKey || '';
            let text = key ? t(key) : it.defaultText || '';
            if ((!text || text === key) && it.defaultText) text = it.defaultText;
            return (
                <span key={`txt-${idx}-${suffix}`} className="marquee-item">
                    {text}
                </span>
            );
        }
    }).filter(n => {
        // remove empty strings
        if (n.props && typeof n.props.children === 'string') {
            return n.props.children.trim() !== '';
        }
        return true;
    });

    const firstLoop = renderNodes('a');
    const secondLoop = renderNodes('b');

    if (firstLoop.length === 0) {
        return (
            <div className="marquee-wrapper">
                <div className="marquee-fallback">
                    {t('ad_marquee_community', 'Join the Gonkle community')}
                </div>
            </div>
        );
    }

    return (
        <div className="marquee-wrapper">
            <div className="marquee-content">
                {firstLoop}
                {secondLoop}
            </div>
        </div>
    );
};

export default Marquee;
